import clienteAxios from "../config/axios";

export async function getProviders () {
    return clienteAxios.get(`/proveedores`);
}

export async function getProvidersDistinct () {
    return clienteAxios.get(`/proveedores/distinct`);
}

export async function uploadProvider ( userID, userName) {
    return clienteAxios.post('/actualizar/proveedor', {userID, userName});
}